import { render, staticRenderFns } from "./ParaNoteContextMenu.vue?vue&type=template&id=02c4b327"
import script from "./ParaNoteContextMenu.vue?vue&type=script&lang=js"
export * from "./ParaNoteContextMenu.vue?vue&type=script&lang=js"
import style0 from "./ParaNoteContextMenu.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports